<template>
    <vuex-select
        :placeholder="toSentenceCase($tkey('placeholder.selectProvision'))"
        :options="params.options"
        :item-text="params.itemText"
        :item-value="params.itemValue"
        :getter="() => internalValue"
        :name="`${params.node.data?.productKey}-provision-autocomplete`"
        :sort-results="false"
        :setter="newValue => updateInternalValue(newValue)"
        :validate-on-blur="false"
        :clearable="params.clearable"
        :disabled="isDisabled"
        css-class="ag-autocomplete"
        filled
    />
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    localizationKey: 'planning.nominations.detailedProvision',
    props: {
        params: { type: Object, required: true },
    },
    data() {
        return {
            internalValue: null,
        };
    },
    computed: {
        isDisabled() {
            return this.isReadOnly || this.params.context?.isReadOnly();
        },
    },
    created() {
        this.internalValue = this.params.value?.key;
    },
    methods: {
        updateInternalValue(newValue) {
            this.internalValue = newValue;
            const colId = this.params.column.colId;
            this.params.node.setDataValue(colId, newValue);

            this.onChange(newValue);
        },

        onChange(value) {
            const { productKey } = this.params.node.data;
            this.params.onChange({
                productKey,
                model: value,
            });
            // Refresh only this cell for performance.
            const colId = this.params.column.colId;
            this.params.api.refreshCells({ rowNodes: [this.params.node], columns: [colId] });
        },
    },
});
</script>

<style lang="scss">
.ag-autocomplete {
    &:deep(.v-input__control .v-select__slot input) {
        padding-left: 0.5rem;
        padding-left: 0;
    }

    &:deep(.v-input__append-inner) {
        padding-left: 0;
    }

    .v-field {
        min-width: 0 !important;
    }
}
</style>
